import React, { Component } from 'react';
import TextField from 'material-ui/TextField';
import Button from 'material-ui/RaisedButton';
import styled from 'styled-components';


const Container = styled.div`
  display: flex;
  max-width: 450px;
  margin: 0 auto;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  height: 100vh;
  padding: 8px 16px;
`

const FormGroup = styled.div`
  padding: 16px 8px;
`

const SubmitButton = styled(Button)`
  width: 100%;
`
class Login extends Component {
  state = {
    email: '',
    password: ''
  }

  _handleChange = event => {
    this.setState({
      [event.target.name]: event.target.value
    });
  }

  _handleSubmit = event => {
    event.preventDefault();
    this.props.loginUser({
      email: this.state.email,
      password: this.state.password
    })
  }

  render(){
    return(
      <form onSubmit={this._handleSubmit} >
        <Container>
          <FormGroup>
            <TextField
              fullWidth
              required
              id="email"
              name="email"
              floatingLabelText="Email"
              value={this.state.email}
              onChange={this._handleChange}

            />
          </FormGroup>
          <FormGroup>
            <TextField
              fullWidth
              required
              id="password"
              name="password"
              type="password"
              floatingLabelText="Password"
              value={this.state.password}
              onChange={this._handleChange}

            />
          </FormGroup>
          <FormGroup>
            <SubmitButton color="primary" type="submit">
              {'Login'}
            </SubmitButton>
          </FormGroup>
        </Container>
      </form>
    )
  }
}


export default Login;



// WEBPACK FOOTER //
// ./src/components/Auth/Login.js